import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/allowances";

// Fetch Allowances
export const fetchAllowances = createAsyncThunk("allowances/fetch", async (_, { rejectWithValue }) => {
  try {
    const response = await hrmsGetRequest(API_URL);
    console.log("Fetch Allowances Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Fetch Allowances Error:", error.response?.data);
    return rejectWithValue(error.response?.data?.message || "Failed to fetch allowances");
  }
});

// Add Allowance
export const addAllowance = createAsyncThunk("allowances/add", async (allowanceData, { rejectWithValue }) => {
  try {
    const response = await hrmsPostRequest(API_URL, allowanceData);
    console.log("Add Allowance Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Add Allowance Error:", error.response?.data);
    return rejectWithValue(error.response?.data?.message || "Failed to add allowance");
  }
});

// Update Allowance
export const updateAllowance = createAsyncThunk("allowances/update", async ({ id, updatedData }, { rejectWithValue }) => {
  try {
    const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
    console.log("Update Allowance Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Update Allowance Error:", error.response?.data);
    return rejectWithValue(error.response?.data?.message || "Failed to update allowance");
  }
});

// Delete Allowance
export const deleteAllowance = createAsyncThunk("allowances/delete", async (id, { rejectWithValue }) => {
  try {
    await hrmsDeleteRequest(`${API_URL}/${id}`);
    console.log("Delete Allowance Success: ID", id);
    return id;
  } catch (error) {
    console.error("Delete Allowance Error:", error.response?.data);
    return rejectWithValue(error.response?.data?.message || "Failed to delete allowance");
  }
});

const allowanceSlice = createSlice({
  name: "allowances",
  initialState: {
    allowances: [],
    status: "idle",
    error: null,
    deleteStatus: "idle",
  },
  reducers: {
    resetDeleteStatus: (state) => {
      state.deleteStatus = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Allowances
      .addCase(fetchAllowances.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllowances.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allowances = action.payload;
        state.error = null;
      })
      .addCase(fetchAllowances.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Allowance
      .addCase(addAllowance.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addAllowance.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allowances.push(action.payload);
        state.error = null;
      })
      .addCase(addAllowance.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Allowance
      .addCase(updateAllowance.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateAllowance.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.allowances.findIndex((a) => a.id === action.payload.id);
        if (index !== -1) {
          state.allowances[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateAllowance.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Delete Allowance
      .addCase(deleteAllowance.pending, (state) => {
        state.deleteStatus = "loading";
      })
      .addCase(deleteAllowance.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.allowances = state.allowances.filter((a) => a.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteAllowance.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteStatus } = allowanceSlice.actions;
export default allowanceSlice.reducer;